<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{'whatsIncludedSidebars.detailsPriorityBaggage.titles.includedPassenger' | ibeadmin: 'sync'}}</h2>
			<!-- START UNCONFIRMED ANCILLARIES WARNING /-->
			<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
				<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
					[title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
					+ ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
					<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
						<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank" aria-label="Go to refunds page">
							{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
						</a>
						{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
					</div>
				</app-notification>
			</ng-container>
			<!-- END UNCONFIRMED ANCILLARIES WARNING -->
			
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
				<!-- fare related ancillaries for the passenger-->
				<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax)}}</span>
							{{ INDRA_getTranslationKey('includedIn','texts') | ibeadmin:'sync' }}
							<span class="capitalize">{{ INDRA_printBrand() }}</span>.
						</p>
					</div>
				</div>
				
				<!-- tier benefits for the passenger-->
				<div *ngIf="INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length > 0" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax)}}</span>
							{{ INDRA_getTranslationKey('isA','texts') | ibeadmin:'sync' }}
							{{ INDRA_getPassengerTierLabel(passenger) }}
							{{ INDRA_getTranslationKey('benefit','texts') | ibeadmin:'sync' }}.
						</p>
					</div>
				</div>
				
				<!-- purchased ancillaries for the passenger-->
				<div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length == 0" class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<!-- START UNCONFIRMED ANCILLARIES WARNING -->
							<ng-container *ngIf="!item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
							</ng-container>
							<ng-container *ngIf="item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true" [alt]="'Checked icon'">
								</app-svg>
							</ng-container>
							<!-- END UNCONFIRMED ANCILLARIES WARNING -->
							<span class="bold">{{item.ancillaryDetail}}</span><span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span>
						</p>
					</div>
				</div>
				
				<!-- no ancillaries for the passenger-->
				<div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length === 0 && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax).length === 0" class="grid no-padding">
					<div class="bold col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">{{ INDRA_getTranslationKey('notIncluded','texts') | ibeadmin:'sync' }}</p>
					</div>
				</div>
			</div>
		</div>
		

		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{'whatsIncludedSidebars.detailsPriorityBaggage.titles.priorityBaggage' | ibeadmin: 'sync'}}</h2>
			<!-- <h2 class="title-h2">About priority baggage</h2> -->
			<p class="muted">{{'whatsIncludedSidebars.detailsPriorityBaggage.texts.priorityBaggageInfo' | ibeadmin: 'sync'}}</p>
			<!--
			<p>
				When you check in your hold baggage a ticket is issued that allows the owner to be identified. 
				For security reasons, luggage is always checked on the same plane the passenger travels on.
			</p>
			-->
		</div>
		<div class="sidebar-flight-text">
			<p>{{'whatsIncludedSidebars.detailsPriorityBaggage.texts.firstTobeDelivered' | ibeadmin: 'sync'}}</p>
			<!-- <p>With this service your luggage will be among the first to be delivered upon arrival.</p> -->
			<a href="{{'externalURLs.aboutPriorityBaggage' | ibeadmincfg }}"  
				class="link extras-feature__link link--external" 
				aria-label="Open All about priority baggage, opens new window">
				<!-- All about priority baggage -->
				{{'whatsIncludedSidebars.detailsPriorityBaggage.texts.allAboutPBAGG' | ibeadmin: 'sync'}}
			</a>
		</div>

		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog" 
					(click)="INDRA_handleClose()"
					href="javascript:;" 
					role="button">
					{{'whatsIncludedSidebars.detailsPriorityBaggage.texts.closeWindow' | ibeadmin: 'sync'}}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer"></div>
</div>
